import { render } from "./AllSubscription.vue?vue&type=template&id=20d76c55"
import script from "./AllSubscription.vue?vue&type=script&lang=js"
export * from "./AllSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafedenj-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__